import { useEffect, useState, useCallback } from 'react'

export function useGpsDataCollapsed(unifiedVehicle: uui.domain.client.UnifiedVehicle) {
  const { unifiedId } = unifiedVehicle

  const [collapsed, setCollapsed] = useState(true)

  const toggleCollapsed = useCallback(() => {
    setCollapsed(prev => !prev)
  }, [])

  // product choice: when the vehicle changes, set the collapsed to true
  useEffect(() => {
    setCollapsed(true)
  }, [unifiedId])

  return { collapsed, setCollapsed, toggleCollapsed }
}
